<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ded"> </p>
<p class="DED"><span class="ePub-I">This book is for Gardner Dozois and Rich Horton, who awaited each original post with such enthusiasm, and whose well-informed comments make this their book almost as much as mine. And it is for Kevin Standlee, in recognition of his tireless and mostly thankless work for the Hugos and WSFS over many years.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?625c4b76